import { Equipement } from './equipement.model';
import { Piece } from './piece.model';

export class PieceEquipement {
    id: number;
    piece_id: number;
    piece: Piece;
    equipement_id: number;
    equipement: Equipement;
    quantite: number;
    date_installation: string;
    date_recuperation: string;
    user_id: number;
    heuredh: string;

    public constructor(init?: Partial<PieceEquipement>) {
      Object.assign(this, init);
    }
  }
